<template>
  <div class="configScreen">
    <el-tabs @tab-click="handleClick" stretch>
      <el-tab-pane v-for="(item, index) in allConfig1" :label="item.name" :key="item.index">
        <el-table :data="item.jsonarr" style="width: 100%" stripe :row-class-name="tableRowClassName"
          :cell-style="{ padding: '0' }" @row-click="rowClick" :tree-props="{ children: 'child' }" row-key="id">
          <el-table-column prop="name" label="参数名称" width="100%" align="right"></el-table-column>
          <el-table-column label="设置值" align="left" prop="value" width="100%">
            <template slot="header">
              <span>设置值</span>
              <el-tooltip class="item" effect="dark" content="下载配置" placement="top-start">
                <i class="el-icon-download" @click="download(item)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="更改历史" placement="top-start">
                <i class="el-icon-document" @click="searchhistory(item)"></i>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <el-input v-model="scope.row.value" align="left" @change="changeAction(item, index, scope.row)"
                :disabled="!!scope.row.child">
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="调参历史记录" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" class="dialogbox">
      <div style="display:flex;align-items: center;">
        <div style="margin-right: 20px;">
          <el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div style="margin-right: 20px;">
          <el-radio v-model="searchtbale.owner" label="true" @click.native="onRadioChange($event)">是否只查询本人</el-radio>
        </div>
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>

      <div v-if="showtable">
        <template>
          <el-table :data="confighistory" style="width: 100%">
            <el-table-column prop="key" label="参数名称" width="180">
            </el-table-column>
            <el-table-column prop="origin_value" label="旧值" width="180">
            </el-table-column>
            <el-table-column prop="new_value" label="新值">
            </el-table-column>
            <el-table-column prop="handler_name" label="修改人员">
            </el-table-column>
            <el-table-column prop="reason" label="修改原因">
            </el-table-column>
            <el-table-column prop="updated_at" label="修改时间">
            </el-table-column>
            <!-- <el-table-column prop="new_value" label="地址">
            </el-table-column>
            <el-table-column prop="new_value" label="地址">
            </el-table-column> -->
          </el-table>
        </template>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>



<script>
import config from '@/utils/config';
export default {
  data() {
    return {
      allConfig: [],
      allConfig1: [],
      allNewValue: null,
      rowChange: 0,
      result1: {},
      clickIndex: 0,
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      changename: null,
      dialogVisible: false,
      value1: "",
      searchtbale: {
        owner: 'false',
        module: '',
        start_at: '',
        end_at: ''
      },
      confighistory: null,
      showtable: false

    };
  },
  mounted() {
    this.getConfigAll();
    this.getConfigAll1();
  },
  beforeDestroy() {
    window.sessionStorage.setItem("loginIndex1", 1);
  },
  methods: {
    download(item, asFilename) {
      let jsonData = item.result
      const filename = asFilename || `${(item.index)}.json`;
      const data = typeof jsonData === 'object' ? JSON.stringify(jsonData, undefined, 2) : jsonData;
      const blob = new Blob([data], { type: 'text/json' });
      const link = document.createElement('a');
      link.setAttribute('style', 'display: none');
      link.download = filename;
      link.href = window.URL.createObjectURL(blob);
      link.dataset.downloadurl = ['text/json', link.download, link.href].join(':');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleClick(tab, event) {
      // console.log(tab, event);
    },

    async getConfigAll() {
      const { data: res } = await this.$http.get(config.httpPrefix + "/modules/getconfigall");
      this.allConfig = res.data.result;
    },
    async getConfigAll1() {
      const { data: res1 } = await this.$http.get(config.httpPrefix + "/modules/getconfigall");
      this.allConfig1 = res1.data.result;
      console.log(this.allConfig1);
      let jsonobj = []
      this.allConfig1.forEach((data) => {

        data.jsonarr = this.jsontoarr(data.result)
        this.jsontoarr(data.result)

      });
      console.log(this.allConfig1);

    },
    getOrgIdArr(data, val) {//递归父级key
      for (const element of data) {
        if (element.index == val) {
          return [element.name];
        }
        if (element.child) {
          var far = this.getOrgIdArr(element.child, val);
          if (far) {
            return far.concat(element.name);
          }
        }
      }
    },

    jsontoarr(some, fakey) {
      // console.log(some);
      let somearr = []
      for (let key in some) {
        if (typeof some[key] === "object") {
          if (
            Array.isArray(some[key])
          ) {
            if (typeof some[key][0] === "object") {
              if (
                Array.isArray(some[key])
              ) {
                somearr.push(
                  {
                    name: key,
                    id: key + 'arr2' + fakey,
                    child: this.jsontoarr(some[key], key)
                  })
              } else {
                somearr.push(
                  {
                    name: key,
                    id: key + 'obj2' + fakey,
                    value: some[key]
                  }
                )
              }
            } else {
              somearr.push(
                {
                  name: key,
                  id: key + 'num2' + fakey,
                  value: '[' + some[key] + ']'
                }
              )
            }
          } else {
            // console.log(some[key] == null);
            if (some[key] == null) {
              somearr.push(
                {
                  name: key,
                  id: key + 'obj1' + fakey,
                  value: some[key]
                })
            } else if (some[key].name) {
              somearr.push(
                {
                  name: key,
                  id: key + 'obj1' + fakey,
                  child: this.jsontoarr(some[key], key)
                })
            } else {

              somearr.push(
                {
                  name: key,
                  id: key + 'obj1' + fakey,
                  child: this.jsontoarr(some[key], key)
                })
            }
          }
        } else {
          if (Array.isArray(some[key])) {
            somearr.push(
              {
                name: key,
                id: key + 'arr1' + fakey,
                value: '[' + some[key] + ']'
              }
            )
          } else {
            somearr.push(
              {
                name: key,
                id: key + 'num' + fakey,
                value: some[key]
              }
            )
          }
        }
      }
      return somearr
    },

    async changeAction(item, index, row) {
      console.log(item);
      console.log(row);
      console.log(this.allConfig1);
      // console.log(
      //   this.getOrgIdArr(item.jsonarr, row.index)
      //   // this.getParentIds(item.jsonarr, row.index)
      // );
      const result = this.getOrgIdArr(item.jsonarr, row.index, []).reverse()
      let jsonstring = result.join('.')
      console.log(jsonstring)
      const confirmResult = await this.$prompt('请输入参数修改原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: "warning",
      }).then(async ({ value }) => {
        const one = [];
        const two = [];
        const three = {};
        const four = {};
        for (let i = 0; i < this.allConfig1[index].result.length; i++) {
          one.push(this.allConfig1[index].result[i].name);
          two.push(this.allConfig1[index].result[i].value);
        }
        for (let j = 0; j < one.length; j++) {
          three[one[j]] = two[j];
        }
        // console.log(three);

        const one1 = [];
        const two1 = [];
        const three1 = {};
        for (let x = 0; x < this.allConfig[index].result.length; x++) {
          one1.push(this.allConfig[index].result[x].name);
          two1.push(this.allConfig[index].result[x].value);
        }
        for (let y = 0; y < one1.length; y++) {
          three1[one1[y]] = two1[y];
        }
        console.log(row.value);

        // if (
        //   this.allConfig1[index].result[this.rowChange].value !=
        //   this.allConfig[index].result[this.rowChange].value
        // ) {
        const bianliang = {};
        bianliang[jsonstring] = row.value
        // this.allConfig1[index].result[this.rowChange].value;
        console.log(bianliang);
        const { data: res } = await this.$http.post(config.httpPrefix + "/modules/setconfig", {

          index: item.index,
          update: bianliang,
          reason: value
        });
        console.log(bianliang);
        if (res.meta.status == 200) {
          this.getConfigAll();
          this.getConfigAll1();
          return this.$message.success(res.meta.msg);
        }
        if (res.meta.status != 200) {
          this.getConfigAll();
          this.getConfigAll1();
          return this.$message.error(res.meta.msg);
        }
        // this.$message({
        //   type: 'success',
        //   message: '你的邮箱是: ' + value
        // });
        // return
      }).catch(() => {
        this.getConfigAll1();
        this.$message({
          type: 'info',
          message: '取消了修改！'
        });
      });

    },
    CancelgetConfig() {
      this.getConfigAll1();
      this.$message.info("取消修改！");
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    rowClick(row) {
      this.rowChange = row.index;
      console.log(this.rowChange);
    },
    gotoControl() {
      this.$router.push("/AI/control");
    },

    onRadioChange(e) {
      // console.log(e.target.tagName);
      if (e.target.tagName === "INPUT") {
        if (this.searchtbale.owner == 'false') {
          // this.form.radio = "1";
          this.searchtbale.owner = 'true'
        } else {
          // this.form.radio = "";
          this.searchtbale.owner = 'false'
        }
      }
      console.log(123);
    },
    searchhistory(item) {
      // console.log(item);
      this.searchtbale.module = item.index
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.showtable = false
      this.value1 = []
      this.confighistory = {}
    },
    async search() {
      // console.log(this.value1);
      // console.log(this.searchtbale);
      this.searchtbale.start_at = this.value1[0]
      this.searchtbale.end_at = this.value1[1]
      // const { data: res } = await this.$http.get("/modules/config/update/history");
      // const { data: res } = await this.$http.get(config.httpPrefix + "/modules/config/update/history");  {
      //   params: this.searchtbale,
      // });
      const { data: res } = await this.$http.get(config.httpPrefix + "/modules/config/update/history", {
        params: this.searchtbale,
      });
      this.showtable = true
      this.confighistory = res.data.data
      // console.log(res.data.data);

    }
  },
};
</script>

<style lang="scss" scoped>
.configScreen {
  margin: 50px;
  margin-top: 20px;

  .el-table {
    width: 100% !important;

    .el-table-column {
      width: 100% !important;
    }
  }
}

.setButton {
  width: 100%;
  text-align: center;

  .el-button {
    margin-right: 200px !important;
    margin-left: 200px !important;
    width: 200px;
    margin-top: 30px;
  }
}

.dialogbox {
  ::v-deep .el-input__inner {
    // text-align: center !important;
    // border: none !important;
    border: 1px solid #bebebe !important;
    background: transparent !important;
  }
}

// ::v-deep .el-tabs__nav-scroll {
//   width: 40%;
//   margin: 0 auto;
// }
::v-deep .el-table__body {
  width: 100% !important;
}

::v-deep .el-table__header {
  width: 100% !important;
}

::v-deep .el-input__inner {
  text-align: left !important;
  border: none !important;
  background: transparent !important;
}

::v-deep .el-input__inner:focus {
  border: 1px solid #a88247 !important;
}
</style>
